import { getFromLocalStorage, STORAGE_KEYS } from "./LocalStorage";
import { isRole, ROLES } from "../Constants/RoleConstants";

/** Prefix a route with the tenant slug used by non-admin sessions. */
export function orgPath(path: string): string {
  const user = getFromLocalStorage(STORAGE_KEYS.LOGGED_IN_USER);
  const slug = user?.slug;
  if (!slug || isRole(user?.role, ROLES.IZBA_ADMIN)) return path;
  return `/${slug}${path}`;
}
